import { render, staticRenderFns } from "./NewBasicEmployee.vue?vue&type=template&id=1ab53916&scoped=true&"
import script from "./NewBasicEmployee.vue?vue&type=script&lang=js&"
export * from "./NewBasicEmployee.vue?vue&type=script&lang=js&"
import style0 from "./NewBasicEmployee.vue?vue&type=style&index=0&id=1ab53916&scoped=true&lang=css&"
import style1 from "./NewBasicEmployee.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab53916",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ab53916')) {
      api.createRecord('1ab53916', component.options)
    } else {
      api.reload('1ab53916', component.options)
    }
    module.hot.accept("./NewBasicEmployee.vue?vue&type=template&id=1ab53916&scoped=true&", function () {
      api.rerender('1ab53916', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Payroll/NewBasicEmployee.vue"
export default component.exports